export function formatarTelefoneMundial(numero: string): string {
  if (!numero) return "---";
  const limpo = String(numero).replace(/\D/g, "");

  if (limpo.startsWith("351") && limpo.length === 12) {
    const numero = limpo.slice(3);
    return `+351 ${numero.slice(0, 3)} ${numero.slice(3, 6)} ${numero.slice(6, 9)}`;
  }
  // Determine country code and the rest of the number
  let codPais = "55"; // default to BR when not provided
  let resto = limpo;

  if (limpo.length > 11) {
    if (limpo.startsWith("55")) {
      codPais = limpo.slice(0, 2);
      resto = limpo.slice(2);
    } else {
      // fallback: assume first 2 digits are country code
      codPais = limpo.slice(0, 2);
      resto = limpo.slice(2);
    }
  }

  // agora resto deve ser 10 ou 11 (ddd + número)
  if (resto.length === 11) {
    const ddd = resto.slice(0, 2);
    const parte1 = resto.slice(2, 7);
    const parte2 = resto.slice(7);
    return `+${codPais} ${ddd} ${parte1}-${parte2}`;
  }

  if (resto.length === 10) {
    const ddd = resto.slice(0, 2);
    const parte1 = resto.slice(2, 6);
    const parte2 = resto.slice(6);
    return `+${codPais} ${ddd} ${parte1}-${parte2}`;
  }

  return "---";
}
